export const handleScheduleSubmit = async ({
  assessmentId,
  formData,
  scheduleData,
  isCreateFlow,
  toast,
  scheduleAssessment,
  refetch,
  refetchAssessmentData,
  onClose,
}) => {
  try {
    const params = {
      ...formData,
      ...scheduleData,
    };

    const result = await scheduleAssessment({
      payload: { assessmentId, params },
    });

    if (result?.data?.id) {
      if (isCreateFlow) {
        toast({
          title: 'Assessment scheduled successfully',
        });
        refetch();
        onClose();
      } else {
        refetchAssessmentData();
      }
      return true;
    } else {
      toast({
        title: isCreateFlow
          ? 'Scheduling assessment failed'
          : 'Updating schedule failed',
        status: 'error',
        description: result?.error?.[0] || '',
      });
      return false;
    }
  } catch (error) {
    toast({
      title: 'Error scheduling assessment',
      status: 'error',
      description: error?.message || '',
    });
    return false;
  }
};

export const handleCancelSchedule = async ({
  assessmentId,
  scheduleRef,
  toast,
  cancelScheduledAssessment,
  refetchAssessmentData,
}) => {
  try {
    const result = await cancelScheduledAssessment({
      payload: { assessmentId },
    });

    if (result?.data?.id) {
      toast({
        title: 'Schedule cancelled successfully',
      });
      scheduleRef?.current?.setValues({
        schedule_at: null,
      });
      refetchAssessmentData();
      return true;
    } else {
      toast({
        title: 'Cancelling schedule failed',
        status: 'error',
        description: result?.error?.[0] || '',
      });
      return false;
    }
  } catch (error) {
    toast({
      title: 'Error cancelling schedule',
      status: 'error',
      description: error?.message || '',
    });
    return false;
  }
};
